import React from 'react'

interface ProgressBarProps {
  value: number
  maxValue?: number
  height?: number | string
  backgroundColor?: string
  foregroundColor?: string
  rounded?: boolean
  showLabels?: boolean
  labels?: string[]
  showMarker?: boolean
  markerPosition?: number
  customSegments?: Array<{
    color: string
    width: string | number
    rounded?: 'start' | 'end' | 'all' | 'none'
  }>
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  maxValue = 100,
  height = '8px',
  backgroundColor = 'bg-light',
  foregroundColor = 'bg-primary',
  rounded = true,
  showLabels = false,
  labels = [],
  showMarker = false,
  markerPosition,
  customSegments,
}) => {
  // Calculate percentage value
  const percentage = Math.min((value / maxValue) * 100, 100)
  const markerPos = markerPosition !== undefined ? markerPosition : percentage

  return (
    <div className='d-flex flex-column'>
      {showLabels && labels.length > 0 && (
        <div className='d-flex justify-content-between align-items-center mb-3'>
          {labels.map((label, index) => (
            <span key={index} className='text-muted fs-7'>
              {label}
            </span>
          ))}
        </div>
      )}

      <div
        className={`h-${typeof height === 'number' ? height + 'px' : height} ${backgroundColor} ${
          rounded ? 'rounded' : ''
        }`}
      >
        {customSegments ? (
          <div className='d-flex overflow-hidden h-100'>
            {customSegments.map((segment, index) => (
              <div
                key={index}
                className={`h-100 ${segment.color} ${
                  segment.rounded === 'start'
                    ? 'rounded-start'
                    : segment.rounded === 'end'
                    ? 'rounded-end'
                    : segment.rounded === 'all'
                    ? 'rounded'
                    : ''
                }`}
                style={{width: segment.width}}
              ></div>
            ))}
          </div>
        ) : (
          <div
            className={`h-100 ${foregroundColor} ${rounded ? 'rounded' : ''}`}
            style={{width: `${percentage}%`}}
          ></div>
        )}
      </div>

      {showMarker && (
        <div className='mt-2 position-relative'>
          <div
            className='position-absolute top-0 translate-middle-x'
            style={{
              left: `${markerPos}%`,
            }}
          >
            <div className='d-flex flex-column align-items-center'>
              <i className='bi bi-caret-up-fill fs-4 text-dark'></i>
              <span className='badge badge-primary rounded-circle p-5px'></span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProgressBar
